import axios from "axios"

export const saveBankroll = async (bankroll, email) => {
    try {
        const accessToken = window.localStorage.getItem('access_token')

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/set_bankroll?email=${email}&bankroll=${bankroll}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        })
    
        const user = JSON.parse(window.localStorage.getItem('userdb'));
        user.bankroll = bankroll;
    
        window.localStorage.setItem('userdb', JSON.stringify(user));
    
        
        return res.data;
    } catch(e) {
        console.log(e)
        return false
    }
    
}